import * as React from "react";
import { useRouter } from "@tanstack/react-router";

const TITLE_MAP: Record<string, string> = {
  "/": "ホーム",
  "/settings": "設定",
  "/forbidden": "権限エラー",
  // BizSol
  "/bizsol/dashboard": "ダッシュボード",
  "/bizsol/patients-list": "患者様名簿",
  "/bizsol/clinic-list": "医療機関一覧",
  "/bizsol/clinic-detail": "医療機関詳細",
  "/bizsol/company-list": "法人一覧",
  "/bizsol/company-detail": "法人詳細",
  "/bizsol/device-management": "端末管理",
  "/bizsol/device-detail": "端末詳細",
  "/bizsol/invoice-list": "請求一覧",
  "/bizsol/basic-info": "基本情報",
  "/bizsol/patient-detail": "患者詳細",
  "/bizsol/password-change": "パスワード変更",
  // Clinic
  "/clinic": "ダッシュボード",
  "/clinic/dashboard": "ダッシュボード",
  "/clinic/patient-list": "患者様名簿",
  "/clinic/reservation-list": "予約一覧",
  "/clinic/reservation-slots": "予約枠管理",
  "/clinic/online-consultation": "オンライン診療",
  "/clinic/basic-info": "基本情報",
  "/clinic/invoice-list": "請求一覧",
  "/clinic/patient-detail": "患者詳細",
  "/clinic/device-management": "端末管理",
  "/clinic/password-change": "パスワード変更",
  "/clinic/terms-of-use": "利用規約とプライバシーポリシー",
  // Patient
  "/patient/home": "ホーム",
  "/patient/task-list": "やること一覧",
  "/patient/reservation/completed": "予約完了",
  "/patient/questionnaire": "初回問診",
  "/patient/terms-of-use": "利用規約とプライバシーポリシー",
  "/patient/profile": "プロフィール設定",
  "/patient/payment/method": "支払い方法選択",
  "/patient/payment/card/change": "カード変更",
  "/patient/payment/channel/change": "支払い方法変更",
  "/patient/payment/konbini/change": "コンビニ変更",
  "/patient/payment/result": "決済結果",
  "/patient/insurance/upload": "保険証アップロード",
  "/patient/identity/upload": "本人確認書類アップロード",
  "/patient/invoice-list": "請求履歴",
  "/patient/diagnostic-report/list": "診断レポート一覧",
  "/patient/address/edit": "住所を編集",
  "/patient/name/edit": "氏名を編集",
  "/patient/notification-list": "おしらせ一覧",
  "/patient/reservation": "予約",
  "/patient/reservation-cancel-confirm": "予約キャンセル確認",
  "/patient/password-change": "パスワード変更",
};

function resolveTitle(pathname: string): string {
  if (TITLE_MAP[pathname]) return TITLE_MAP[pathname];
  // Dynamic segments
  if (pathname.startsWith("/patient/call/controls/")) return "通話操作";
  return "SASオンラインクリニック";
}

/**
 * React effect component that keeps document.title in sync with router location.
 */
export function DocumentTitle() {
  const router = useRouter();

  React.useEffect(() => {
    const apply = () => {
      const path = router.state.location.pathname;
      if (typeof document !== "undefined") {
        // ページタイトルは常に固定化
        document.title = "SASオンラインクリニック";
      }
    };

    // Set on mount
    apply();
    // Subscribe to router state changes
    const unsubResolved = router.subscribe("onResolved", () => apply());
    return () => {
      unsubResolved();
    };
  }, [router]);

  return null;
}

export default DocumentTitle;
